import React from "react";
import { Navigate } from "react-router-dom";
import ContainerRedirect from "../../../../../pages/lib/page-redirect";

const ContainerCheckPointListComponent = React.lazy(
  () => import("../../../../../components/workflow-two/components/list/page")
);
const ContainerCheckPointAddComponent = React.lazy(
  () => import("../../../../../components/workflow-two/components/add/page")
);

export const workflowTwoRoute = [
  {
    path: "list",
    element: <ContainerCheckPointListComponent />,
  },
  {
    path: "add",
    element: <ContainerCheckPointAddComponent />,
  },
  {
    path: "edit",
    element: <Navigate to="/workflow/two/add" />,
  },
  {
    path: "edit/:id",
    element: <ContainerCheckPointAddComponent />,
  },
  {
    path: "",
    element: <ContainerRedirect elroute="/workflow/two"/>
  },
];
